export enum ProspectMessagesSuppressions {
    None = 0,
    Confirmation = 1,
    Reminder = 2,
    Access = 4,
    Completion = 8,
    VirtualTourReminder = 16,
    PendingSteps = 32
}



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/ProspectMessagesConfigurations.ts